<script setup>
import { Operation, Close, Plus, ArrowDownBold } from "@element-plus/icons-vue";
import { onBeforeUnmount, onMounted, ref, watch } from "vue";
import { useI18nStore } from "@/store/index";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { useRouter } from "vue-router";

const router = useRouter();
const route = useRoute();
const i18nStore = useI18nStore();
const { locale } = useI18n();
const langList = i18nStore.$state.languageList;
const agentLoginUrl = process.env.VUE_APP_AGENT_LOGIN_URL;

const menuShow = ref(false);
const menuProductsShow = ref(false);
const menuSolutionShow = ref(false);
const isScrolled = ref(false);
const dropdownStates = ref({
  products: false,
  solution: false,
});

const toggleMenu = () => {
  menuShow.value = !menuShow.value;
};
// 切换语言
const toggleLanguage = (val) => {
  i18nStore.toggleLanguage(val);
  locale.value = i18nStore.locale;
};
const goHref = () => {
  window.open(process.env.VUE_APP_API_LOGIN_URL, "_blank", "noopener,noreferrer");
};
const goRouter = (url) => {
  menuShow.value = false;
  menuProductsShow.value = false;
  menuSolutionShow.value = false;
  router.push(url);
};

const handleDropdownClick = (url, dropdownKey) => {
  if (dropdownKey) {
    dropdownStates.value[dropdownKey] = false;
  }
  goRouter(url);
};

const setDropdownState = (key, state) => {
  dropdownStates.value[key] = state;
};

const handleScroll = () => {
  isScrolled.value = window.scrollY > 20;
};

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
  handleScroll();
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>

<template>
  <div class="header">
    <!-- <div class="header_bannar"></div> -->
    <div class="header_top" :class="{ scrolled: isScrolled }">
      <div class="header_l relative">
        <img class="logo" src="@/assets/logo.png" alt="" />
        <img class="logo2" src="@/assets/logo.png" alt="" />
        <span class="logo-text">{{ $t('logoText') }}</span>
      </div>

      <div class="header_c">
        <router-link to="/" class="link_item">{{ $t("header.home") }}</router-link>
        <div
          class="nav_item"
          @mouseenter="setDropdownState('products', true)"
          @mouseleave="setDropdownState('products', false)"
        >
          <div class="link_item">
            {{ $t("header.products") }}
            <el-icon
              :size="12"
              color="#000"
              :class="{ rotated: dropdownStates.products }"
              style="margin-left: 5px; transition: transform 0.3s ease"
            >
              <ArrowDownBold />
            </el-icon>
          </div>
          <div class="dropdown" :class="{ open: dropdownStates.products }">
            <div class="dropdown_menu">
              <div class="dropdown_item" @click="handleDropdownClick('/products/omnichannel', 'products')">
                <img src="@/assets/image/header/header01.png" alt="" />
                <span>{{ $t("header.omnichannel") }}</span>
                <span>{{ $t("header.omnichannelText") }}</span>
              </div>
              <div class="dropdown_item" @click="handleDropdownClick('/products/automation', 'products')">
                <img src="@/assets/image/header/header02.png" alt="" />
                <span>{{ $t("header.automation") }}</span>
                <span>{{ $t("header.automationText") }}</span>
              </div>
              <div class="dropdown_item" @click="handleDropdownClick('/products/team', 'products')">
                <img src="@/assets/image/header/header03.png" alt="" />
                <span>{{ $t("header.team") }}</span>
                <span>{{ $t("header.teamText") }}</span>
              </div>
              <div class="dropdown_item" @click="handleDropdownClick('/products/crm', 'products')">
                <img src="@/assets/image/header/header04.png" alt="" />
                <span>{{ $t("header.crm") }}</span>
                <span>{{ $t("header.crmText") }}</span>
              </div>
              <div class="dropdown_item" @click="handleDropdownClick('/products/analytics', 'products')">
                <img src="@/assets/image/header/header05.png" alt="" />
                <span>{{ $t("header.analytics") }}</span>
                <span>{{ $t("header.analyticsText") }}</span>
              </div>
              <div class="dropdown_item" @click="handleDropdownClick('/products/translate', 'products')">
                <img src="@/assets/image/header/header06.png" alt="" />
                <span>{{ $t("header.translate") }}</span>
                <span>{{ $t("header.translateText") }}</span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="nav_item"
          @mouseenter="setDropdownState('solution', true)"
          @mouseleave="setDropdownState('solution', false)"
        >
          <div class="link_item">
            {{ $t("header.solution") }}
            <el-icon
              :size="12"
              color="#000"
              :class="{ rotated: dropdownStates.solution }"
              style="margin-left: 5px; transition: transform 0.3s ease"
            >
              <ArrowDownBold />
            </el-icon>
          </div>
          <div class="dropdown" :class="{ open: dropdownStates.solution }">
            <div class="dropdown_menu" style="justify-content: center; gap: 30px;">
              <div class="dropdown_item" style="width: 40%;" @click="handleDropdownClick('/solution/Messenger', 'solution')">
                <img src="@/assets/image/header/headericon.png" alt="" />
                <span>{{ $t("header.Messenger") }}</span>
                <span>{{ $t("header.MessengerText") }}</span>
              </div>
              <div class="dropdown_item" style="width: 40%;" @click="handleDropdownClick('/solution/OwnedChannel', 'solution')">
                <img src="@/assets/image/header/headericon2.png" alt="" />
                <span>{{ $t("header.OwnedChannel") }}</span>
                <span>{{ $t("header.OwnedChannelText") }}</span>
              </div>
            </div>
          </div>
        </div>
        <router-link to="/integration" class="link_item">{{ $t("header.integrate") }}</router-link>
        <router-link to="/plan" class="link_item">{{ $t("header.plan") }}</router-link>
        <router-link to="/contact" class="link_item">{{ $t("header.contact") }}</router-link>
      </div>
      <div class="header_r relative">
        <a :href="agentLoginUrl" class="become_agent" target="_blank">{{ $t("header.becomeAgent") }}</a>
        <div class="login_btn" @click="goHref">
          {{ $t("login") }}
        </div>
        <el-dropdown trigger="click">
          <img
            class="relative"
            style="width: 22px; height: 22px; cursor: pointer"
            src="@/assets/image/header/lang.png"
            alt=""
          />
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="(item, index) in langList"
                :key="index"
                class="lang_item"
                :class="item.value === locale ? 'active-link' : ''"
                @click="toggleLanguage(item.value)"
                >{{ item.label }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <div style="height: 100%">
          <el-icon class="rIcon relative" @click="toggleMenu"><Close v-if="menuShow" /><Operation v-else /></el-icon>
          <div class="menu" v-show="menuShow">
            <div class="m_menu">
              <div @click="goRouter('/')" class="menu_item">{{ $t("header.home") }}</div>
              <div class="m_menu_item">
                <div class="menu_item" @click="menuProductsShow = !menuProductsShow">
                  <span>{{ $t("header.products") }}</span>
                  <el-icon :size="16"><Close v-if="menuProductsShow" /><Plus v-else /></el-icon>
                </div>
                <div class="m_menu_dropdown" v-if="menuProductsShow">
                  <div @click="goRouter('/products/omnichannel')">{{ $t("header.omnichannel") }}</div>
                  <div @click="goRouter('/products/automation')">{{ $t("header.automation") }}</div>
                  <div @click="goRouter('/products/team')">{{ $t("header.team") }}</div>
                  <div @click="goRouter('/products/crm')">{{ $t("header.crm") }}</div>
                  <div @click="goRouter('/products/analytics')">{{ $t("header.analytics") }}</div>
                  <div @click="goRouter('/products/translate')">{{ $t("header.translate") }}</div>
                </div>
              </div>
              <div class="m_menu_item">
                <div class="menu_item" @click="menuSolutionShow = !menuSolutionShow">
                  <span>{{ $t("header.solution") }}</span>
                  <el-icon :size="16"><Close v-if="menuSolutionShow" /><Plus v-else /></el-icon>
                </div>
                <div class="m_menu_dropdown" v-if="menuSolutionShow">
                  <div @click="goRouter('/solution/Messenger')">{{ $t("header.Messenger") }}</div>
                  <div @click="goRouter('/solution/OwnedChannel')">{{ $t("header.OwnedChannel") }}</div>
                </div>
              </div>
              <div @click="goRouter('/integration')" class="menu_item">{{ $t("header.integrate") }}</div>
              <div @click="goRouter('/plan')" class="menu_item">{{ $t("header.plan") }}</div>
              <div @click="goRouter('/contact')" class="menu_item">{{ $t("header.contact") }}</div>
            </div>
            <div class="m_login_btn" @click="goHref">
              {{ $t("login") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.header {
  width: 100vw;
  position: fixed;
  top: 0;
  z-index: 999;
}
// .header_bannar {
//   position: relative;
//   z-index: 1000;
//   height: 40px;
//   background: #000;
// }
.header_top {
  width: 100%;
  height: 60px;
  padding: 0 2%;
  color: #000;
  user-select: none;
  background-color: rgba(0, 0, 0, 0);
  display: flex;
  justify-content: space-between;
  transition: background-color 0.25s ease, box-shadow 0.25s ease;

  &.scrolled {
    background-color: hsla(0, 0%, 100%, 0.88);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }

  .header_l {
    display: flex;
    align-items: center;

    .logo {
      width: auto;
      height: 38px;
    }
    .logo2 {
      display: none;
      width: 30px;
      height: 30px;
    }
    .logo-text{
      font-weight: bold;
      font-size: 20px;
      color: #003897;
      margin-left: 10px;
    }
  }

  .header_c {
    width: 40%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .link_item {
      height: fit-content;
      display: flex;
      align-items: center;
      font-size: 15px;
      font-weight: 500;
      padding: 10px 0;
      cursor: pointer;
      position: relative;
      z-index: 999;
    }

    .link_item:hover {
      color: #4498ff !important;
    }

    .nav_item {
      display: flex;
      align-items: center;
    }

    .dropdown {
      position: absolute;
      z-index: 99;
      left: 0;
      top: 0;
      width: 100vw;
      background: linear-gradient(180deg, #e8f5ff 0%, #fefefe 64.56%);
      padding: 100px 0 0;
      opacity: 0;
      visibility: hidden;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
      transform: translateY(-20px);
      transition: opacity 0.25s ease, transform 0.25s ease, visibility 0.25s;

      &.open {
        opacity: 1;
        visibility: visible;
        transform: translateY(0);
      }
    }
    .dropdown_menu {
      padding: 0px 15% 40px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .dropdown_item {
        cursor: pointer;
        display: flex;
        flex-direction: column;
        width: 30%;
        padding: 20px;
        border-radius: 20px;
        margin-bottom: 20px;
        transition: all 0.3s ease-in-out;
        img {
          width: 24px;
          height: 24px;
        }
        span:nth-child(2) {
          padding: 10px 0;
          font-size: 16px;
          font-weight: 500;
          color: #000;
        }
        span:nth-child(3) {
          font-size: 14px;
          color: #666;
        }
      }
      .dropdown_item:hover {
        background: #eef5ff;
      }
    }
  }

  .header_r {
    display: flex;
    align-items: center;

    .login_btn {
      cursor: pointer;
      font-size: 14px;
      width: 90px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      color: #fff;
      background: linear-gradient(270deg, #016AFE 0%, #09DAFD 100%);
      border-radius: 20px;
      margin-right: 20px;
    }

    .login_btn:hover {
      opacity: 0.8;
    }
  }
}

.rIcon {
  display: none;
  height: 100%;
  font-size: 25px;
  margin-left: 20px;
}

.menu {
  position: fixed;
  z-index: 99;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(#fff 0%, #f8f8f8 100%);
  padding: 100px 0 0;
  .m_menu {
    display: flex;
    flex-direction: column;
    .menu_item {
      cursor: pointer;
      padding: 10px 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .m_menu_item {
      .m_menu_dropdown {
        div {
          padding: 10px 30px;
        }
      }
    }
  }
  .m_login_btn {
    width: 90%;
    text-align: center;
    margin: 0 auto;
    padding: 8px;
    border-radius: 50px;
    border: 1px solid #4498ff;
    color: #4498ff;
    margin-top: 20px;
  }
  .m_logup_btn {
    width: 90%;
    text-align: center;
    margin: 0 auto;
    padding: 8px;
    border-radius: 50px;
    color: #fff;
    background: #000;
    margin-top: 20px;
  }
}

.become_agent{
  color: #4498ff;
  margin-right: 20px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  text-decoration: solid;
}
.become_agent:hover{
  opacity: 0.8;
}

.relative {
  position: relative;
  z-index: 999;
}

.active-link {
  color: #4498ff !important;
}

.rotated {
  transform: rotate(180deg);
}

@media (max-width: 1150px) {
  // .header_bannar {
  //   position: relative;
  //   z-index: 1000;
  //   height: 30px;
  //   background: #000;
  // }
  .header_top {
    padding: 0 8% !important;
    .header_l {
      .logo {
        display: none !important;
      }
      .logo2 {
        display: block !important;
      }
    }
    .header_c {
      display: none !important;
    }
    .header_r {
      .login_btn {
        display: none !important;
      }
    }
  }

  .rIcon {
    display: flex;
    font-size: 22px;
  }
}
</style>
